import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GenericInformation } from '../models/generic-information.interface';
import { BaseResponse } from '../models/base-response.interface';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  private apiUrl = `${environment.apiUrl}/configurations`;

  constructor(private http: HttpClient) { }

  // Obtener todos los tipos de suscripción disponibles
  getSubscriptionTypes(): Observable<GenericInformation[]> {
    return this.http.get<BaseResponse>(`${this.apiUrl}/subscription-types`)
      .pipe(
        map(response => response.data || [])
      );
  }
} 